import { render } from "./WidgetsUsuario.vue?vue&type=template&id=c113ce8e&scoped=true&ts=true"
import script from "./WidgetsUsuario.vue?vue&type=script&lang=ts"
export * from "./WidgetsUsuario.vue?vue&type=script&lang=ts"

import "./WidgetsUsuario.vue?vue&type=style&index=0&id=c113ce8e&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c113ce8e"]])

export default __exports__